define(
	'checkPreInit/rebrandingSteps',[
		'common/config', './loadingErrors', 'dataSource/oemMessages', 'atn/atn', 'dataSource/uiVersion'
	], 
	function(config, errors, oemMessages, atn, uiVersion) {
	    'use strict';
	    return {
	        reloadFavicon: reloadFavicon,
	        fetchBrandingInfo: fetchBrandingInfo
	    };

	    function reloadFavicon(data, next) {
	    	var faviconPath = atn.config.oemRebrandingFolder + atn.config.oemResourcesMap.FAVICON,
        		uiVersionQueryObj;

        	uiVersionQueryObj = {'id': uiVersion.uiVersion.id};

        	atn.utils.loadFavicon(faviconPath, uiVersionQueryObj);
        	
	        next();
	    }

	    function fetchBrandingInfo(data,next){
	        var promise = oemMessages.getOemMessageStrings();
	        promise.done(function(){
	            atn.config.updateBrandInfo(oemMessages.oemMessages);
	            next();
	        });
	    }
});
